import React from "react"
import { Icon } from "semantic-ui-react"
import ProductModelBase from "theme/base/shop/ProductModel"
import shop from "shop/shop"

export default class ProductModelSandra extends ProductModelBase {
  constructor( data ) {
    super( data )
    this.canBeBought = this.smallestQuantity.multi <= this.stock
  }

  /**
   *
   * @param size : Number
   * @param currentStock : Number
   * @returns {*}
   */

  onChange = ( data ) => {
    const can = this.unit_multi <= this.stock
    return can
  }

  getNotice = ( size ) => {

    // NO AVAIL WHEN NOT LOGGED IN
    if ( !shop.session ) return null

    let product = this
    const isnew = product.extraValue.isnew
    const { stock } = product
    const min = product.smallestQuantity.multi
    //const colorAvailable = product.extraValue.stockColor

    const colorAvailable = product.stock > 0 ? 'green' : 'red'

    if ( size === "tiny" ) {

      if ( colorAvailable == 'blue' ) {
        return notice =  <span><Icon name={"truck"} color={"blue"}/>Vorbestellbar</span>
      }
      if ( colorAvailable == 'yellow' ) {
        return notice =  <span><Icon name={"truck"} color={"yellow"}/>{product.extraValue.stockText}</span>
      }

      if ( colorAvailable == 'green' ) {
        return notice = <span ><Icon name={"truck"} color={"green"}/> Auf Lager </span>
      }

      if ( colorAvailable == 'red' ) {
        return notice = <span><Icon name={"truck"} color={"red"}/> Derzeit nicht verfügbar</span>
      }
    }

    let notice = <span><Icon name={"truck"} color={"red"}/> <span>Nicht verfügbar</span></span>


    if ( colorAvailable == 'blue' ) {
      return notice = <span ><Icon name={"truck"} color={"blue"}/>Vorbestellbar</span>
    }
    if ( colorAvailable == 'yellow' ) {
      return notice =  <span><Icon name={"truck"} color={"yellow"}/>{product.extraValue.stockText}</span>
    }

    if ( colorAvailable == 'green' ) {
      return notice = <span ><Icon name={"truck"} color={"green"}/> Auf Lager </span>
    }

    if ( colorAvailable == 'red' ) {
      return notice = <span><Icon name={"truck"} color={"red"}/> Derzeit nicht verfügbar</span>
    }

    return notice
  }
  

}



// WEBPACK FOOTER //
// ./src/theme/hobbyfun/shop/ProductModel.js